/* global angular */

import './style.less';

export default function() {
  'ngInject';
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/emailEventInfoOptions/controller.js